module.exports = __webpack_public_path__ + "img/INTERIOR-VITARA-5.d5aa5783.jpg";